<template>
  <div class="school">
    <div class="header">
      <span class="createBtn" @click="showShadowView()">成为师父</span>
    </div>
    <div class="items">
      <!-- 我的公司 -->
      <div class="item" v-if="myschool" @click="goDetailPage(myschool)">
        <div class="logo"><img :src="getImg(myschool.logo)" /></div>
        <div class="rightView">
          <span class="title">{{myschool.name}}</span>
          <p class="content">{{myschool.content}}</p>
          <p class="desc">
            <span class="position tab">
              <img class="icon" :src="images.ceo" />
              <span class="text">师父:{{myschool.owner.name}}</span>
            </span>
            <span class="product tab" v-if="myschool.owner.job_title">
              <img class="icon" :src="images.product" />
              <span class="text">级别:{{myschool.owner.job_title}}</span>
            </span>
            <span class="member tab">
              <img class="icon" :src="images.member" />
              <span class="text">徒弟{{myschool.member_count}}人</span>
            </span>
          </p>
        </div>
      </div>
      <!-- 公司列表 -->
      <div class="item" v-for="item in data" :key="item.id" @click="goDetailPage(item)">
        <div class="logo"><img :src="getImg(item.logo)" /></div>
        <div class="rightView">
          <span class="title">{{item.name}}</span>
          <p class="content">{{item.content}}</p>
          <p class="desc">
            <span class="position tab">
              <img class="icon" :src="images.ceo" />
              <span class="text">师父:{{item.owner.name}}</span>
            </span>
            <span class="product tab" v-if="item.owner.job_title">
              <img class="icon" :src="images.product" />
              <span class="text">级别:{{item.owner.job_title}}</span>
            </span>
            <span class="member tab">
              <img class="icon" :src="images.member" />
              <span class="text">徒弟:{{item.member_count}}人</span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <SchoolCreate ref="createschool" tag="shadow">
      <SchoolCreate />
    </SchoolCreate>
  </div>
</template>

<script>
// @ is an alias to /src
import SchoolCreate from './SchoolCreate'

import { Utils } from '@/utils';
import { 
  IMG_COMPANY_CEO_ICON, 
  IMG_COMPANY_PRODUCT_ICON, 
  IMG_COMPANY_INCOME_ICON, 
  IMG_COMPANY_MEMBER_ICON 
} from '@/assets';

import { types as ToastTypes } from "@/store/modules/toast";
import { types as LoginTypes } from "@/store/modules/login";
import { types as SchoolTypes } from "@/store/modules/school";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SchoolList",
  components: {
    SchoolCreate
  },
  props: {},
  data() {
    return {
      images:{
        ceo: IMG_COMPANY_CEO_ICON,
        product: IMG_COMPANY_PRODUCT_ICON,
        income: IMG_COMPANY_INCOME_ICON,
        member: IMG_COMPANY_MEMBER_ICON
      }
    };
  },
  watch: {},
  computed: {
    ...mapState({
      message: state => state.login.message,
      page: state => state.school.school.page,
      load_more: state => state.school.school.load_more,
      data: state => state.school.school.data,
      myschool: state => state.school.mySchool
    })
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchListSchool: SchoolTypes.FETCH_LIST_SCHOOL,
      fetchMySchool: SchoolTypes.FETCH_MY_SCHOOL
    }),
    ...Utils,

    showShadowView(){
      let callback = ()=>{
      // console.log(this.message,"message")
      if(!this.message.segment || this.message.segment.prestige_number <= 100){
        this.showToast({"message":"只有达到黄金及以上段位才可创建学校"})
        return
      }
      this.$refs.createschool.showShadowView()
      }
      this.dependLoginStatus().then(callback)
    },
    // 进入详情页
    goDetailPage(item){
      this.$router.push(`/school/${item.id}`);
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchListSchool({"page":that.page+1})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.fetchListSchool({"page":1});
    // 还没有学校的弹窗，关闭
    // this.dependLoginStatus("no_toast").then(()=>{
    //   this.fetchMySchool()
    // })
  }
};
</script>

<style lang="less" scoped>
.school {
  width: 100%;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 10px;
    .createBtn {
      padding: 5px 15px;
      background-color: #ff7b00;
      border-radius: 15px;
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .items {
    .item {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      margin: 15px;
      margin-bottom: 25px;
      align-items: center;
      .logo{
        width: 100px;
        height: 100px;
        margin-right: 15px;
        border-radius: 8px;
        background-color: #F4F3F3;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img{
          width: 100%;
          max-height: 100%;
        }
      }
      .rightView{
        flex: 1;
        // height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title{
          color: #333333;
          font-size:15px;
          margin-bottom: 5px;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
        }
        .content{
          color: #666666;
          font-size:13px;
          line-height: 23px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 5px;
          // height: 50px;
        }
        .desc{
          display: flex;
          flex-direction: row;
          color: #999999;
          font-size: 13px;
          overflow: hidden;
          height: 20px;
          line-height: 20px;
          .tab{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 20px;
            &.position{
            // flex: 1;
              max-width: 150px;
            }
            &.product{
            }
            &.income{
            }
            &.member{

            }
            .icon{
              // width: 12px;
              height: 15px;
              margin-right: 5px;
            }
            .text{
              color: #999999;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
